import { render, staticRenderFns } from "./OcrField.vue?vue&type=template&id=1b86447e&scoped=true"
import script from "./OcrField.vue?vue&type=script&lang=js"
export * from "./OcrField.vue?vue&type=script&lang=js"
import style0 from "./OcrField.vue?vue&type=style&index=0&id=1b86447e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86447e",
  null
  
)

export default component.exports